/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserActivityDataAnyOf } from './userActivityDataAnyOf';

export type UserActivityData = UserActivityDataAnyOf | null;
